import { createContext, useContext } from 'react'
import { SocialListeningApi, socialListeningApi } from '@/lib/api'

// No default value at module load: the shared client is read on first use, so
// a module that only imports social components never touches it.
const SocialListeningApiContext = createContext<SocialListeningApi | null>(null)

/** The back office scopes the Library's social UI to one org by providing that org's API. */
export const SocialListeningApiProvider = SocialListeningApiContext.Provider

export function useSocialListeningApi(): SocialListeningApi {
  return useContext(SocialListeningApiContext) ?? socialListeningApi
}
